import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useGlobalContext } from '../../AppContext';

import './FloatMenu.scss';

interface FloatMenuProps {
  opened?: boolean;
}

export function FloatMenu(props: FloatMenuProps) {
  const { tutorialCount, setTutorialCount, demoMode, setFirstRun } = useGlobalContext();
  const [opened, setOpened] = useState<boolean>(props.opened);

  const restartFirstRun = () => {
    localStorage.removeItem('firstRun');
    document.location.reload();
  };
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (demoMode) {
      if (tutorialCount === 10) {
        setOpened(true);
        setTimeout(() => {
          setOpened(false);
          setTutorialCount(0);
          setFirstRun(true);
        }, 800);
      }
    }
  }, [tutorialCount]);

  return (
    <>
      {opened && <div className="float-menu-grayed-out" onClick={() => setOpened(false)} />}
      <div className={`float-menu ${opened ? 'opened' : ''}`}>
        <div className="float-menu-container">
          <img
            src="/icon-dark.svg"
            className="normal-icon"
            alt=""
            onClick={() => setOpened(!opened)}
          />
          <img
            src={`/icons/cross-dark.svg`}
            className="close-icon"
            alt=""
            onClick={() => setOpened(!opened)}
          />
          <ul>
            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/about-us' }}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/team' }}
              >
                Team
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/faq' }}
              >
                F.A.Q.
              </Link>
            </li>
            {/*
            <li>
              <Link onClick={() => setOpened(false)}
                target="_blank"
                style={{ opacity: 0.3 }}
                onClick={(event: any) => event.preventDefault()}
                to={{ pathname: 'https://docs.walletscan.co/' }}
              >
                Collaboration
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpened(false)}
                target="_blank"
                style={{ opacity: 0.3 }}
                onClick={event => event.preventDefault()}
                to={{ pathname: 'https://docs.walletscan.co/' }}
              >
                Blog
              </Link>
            </li>
            */}
            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/brand-kit' }}
              >
                Brand Kit
              </Link>
            </li>

            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/privacy-and-terms' }}
              >
                Privacy &amp; Terms
              </Link>
            </li>

            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/feedback' }}
              >
                Feedback
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setOpened(false)}
                target="_blank"
                to={{ pathname: 'https://docs.walletscan.co/feedback' }}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={`settings-menu`}>
        <div className="settings-menu-container">
          <Link onClick={() => setOpened(false)} to={{ pathname: '/settings' }}>
            <img src="/icons/settings.svg" className="normal-icon" alt="" />
          </Link>
        </div>
      </div>
      {opened && (
        <div className='settings-menu-bar'>
          <div className="restart-first-run" onClick={() => restartFirstRun()}>
              Restart Demo
        </div>
        <div className={`settings-menu-mobile`}>
        <div className="settings-menu-container">
          <Link onClick={() => setOpened(false)} to={{ pathname: '/settings' }}>
            <img src="/icons/settings.svg" className="normal-icon" alt="" />
          </Link>
        </div>
      </div>
      </div>
      )}
    </>
  );
}
